import { getCsrfToken } from '../auth/authApi'
import { apiFetch } from '../../shared/http/apiFetch'

export type NavigationPreferences = {
  favoriteMenuKeys: string[]
  recentMenuKeys: string[]
}

export async function getNavigationPreferences(signal?: AbortSignal): Promise<NavigationPreferences> {
  const response = await apiFetch('/api/v1/auth/navigation-preferences', {
    credentials: 'include', signal,
  })
  if (!response.ok) throw new Error('home.loadError')
  return response.json() as Promise<NavigationPreferences>
}

export async function recordNavigationVisit(menuKey: string): Promise<NavigationPreferences> {
  const response = await apiFetch('/api/v1/auth/navigation-visits', {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': await getCsrfToken() },
    body: JSON.stringify({ menuKey }),
  })
  if (!response.ok) throw new Error('home.saveError')
  return response.json() as Promise<NavigationPreferences>
}

export async function setNavigationFavorite(menuKey: string, isFavorite: boolean): Promise<NavigationPreferences> {
  const response = await apiFetch(`/api/v1/auth/navigation-favorites/${encodeURIComponent(menuKey)}`, {
    method: 'PUT', credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': await getCsrfToken() },
    body: JSON.stringify({ isFavorite }),
  })
  if (!response.ok) throw new Error('home.saveError')
  return response.json() as Promise<NavigationPreferences>
}
